function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// Header and search
const megaMenuLinks = document.querySelectorAll(".js-mega-menu-link");
const megaMenuBlockLink = document.querySelectorAll('.js-mega-menu-block-link');
const megaMenuBlockSublinks = document.querySelectorAll('.js-mega-menu-block-sublinks');
const body = document.querySelector("body");
if (megaMenuLinks.length) {
  megaMenuLinks.forEach((link) => {
    link.addEventListener("mouseover", () => {
      body.classList.add("shadow--body");
    });

    link.addEventListener("mouseleave", () => {
      body.classList.remove("shadow--body");

      megaMenuBlockLink.forEach((el) => {
        el.classList.remove('mega-menu__block--active');
      })

      megaMenuBlockSublinks.forEach((el) => {
        el.classList.remove('mega-menu__links--active');
      })
    });
  });
}

megaMenuBlockLink.forEach((el) => {
  el.addEventListener('mouseenter', () => {
    let sublinksTarget = '';
    const linkId = el.getAttribute('data-link-id');
    
    megaMenuBlockLink.forEach((link) => {
      link.classList.remove('mega-menu__block--active');
    })

    megaMenuBlockSublinks.forEach((sublink) => {
      sublink.classList.remove('mega-menu__links--active');

      if (sublink.getAttribute('data-parent-link-id') === linkId) {
        sublinksTarget = sublink;
      }
    });

    if (sublinksTarget) {
      el.classList.add('mega-menu__block--active');
      sublinksTarget.classList.add('mega-menu__links--active');
    }
  });
});

//Add to bag functionality
class AddProduct extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.addProduct.bind(this));
  }

  async addProduct() {
    this.classList.add("loading");
    this.setAttribute("disabled", true);
    const variantId = this.getAttribute("data-id");

    let properties = {};
    let productObj = {
      id: variantId,
      quantity: 1,
      properties: properties,
    };

    let data = JSON.stringify(productObj);
    fetch(`${routes.cart_add_url}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: data,
    }).then(() => {
      this.classList.remove("loading");
      this.removeAttribute("disabled");
      publish(PUB_SUB_EVENTS.cartAdd);
    });
  }

  async getCart() {
    return fetch(`/cart.js`, { ...fetchConfig() })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        return JSON.parse(text);
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("add-product", AddProduct);

//Quantity input
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.minusButton = this.querySelector('button[name="Minus"]');
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));

      if (this.input.value == this.input.min) {
        this.minusButton.setAttribute("disabled", true);
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "Plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    if (this.input.value == this.input.min) {
      this.minusButton.setAttribute("disabled", true);
    } else {
      this.minusButton.removeAttribute("disabled");
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function pauseMedia(element) {
  if (!element) return;

  element.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  element.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  element.querySelectorAll("video").forEach((video) => video.pause());
  element.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function pauseAllMedia() {
  pauseMedia(document);
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.productMedia = document.querySelector('.js-product-media');
    this.productDeferredMedia = this.getAttribute('data-product-deferred-media') == 'true' ? true : false;
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();

      if (this.productMedia && this.productDeferredMedia) {
        this.productMedia.classList.add('product__media--hide-labels');
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SiteSelect extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const input = this.querySelector('.js-site-select-input');
    const label = this.querySelector('.js-site-select-label');

    if (!input || !label) return;

    input.addEventListener('change', (e) => {
      const selectedText = input.options[input.selectedIndex].text;

      if (!selectedText) return;

      label.innerText = selectedText;
    })
  }
}

customElements.define('site-select', SiteSelect);

class ScrollToContent {
  constructor() {
    this.init();
  }

  init() {
    const scrollToContentOuter = document.querySelectorAll('.js-scroll-to-content-outer');

    scrollToContentOuter.forEach((el) => {
      const scrollToContentButton = el.querySelector('.js-scroll-to-content-button');

      if (!scrollToContentButton) return;

      scrollToContentButton.addEventListener('click', (e) => {
        e.preventDefault();

        const nextElement = el.nextElementSibling;
        
        if (nextElement) {
          nextElement.scrollIntoView({
            behavior: 'smooth'
          }); 
        }
      });
    })
  }
}

new ScrollToContent();

class ScrollTo extends HTMLElement {

  constructor(){
    super();
    this.listeners();
  }

  listeners() {
    this.addEventListener('click', (e) => {
      const target = this.getAttribute('data-target');

      if (target) {
        const targetElement = document.querySelector(target);

        if (targetElement) {
          let headerHeight = 0;
          
          const header = document.querySelector('.js-site-header');
          const targetPosition = targetElement.getBoundingClientRect().top;

          if (header) {
            headerHeight = header.offsetHeight;
          }
          
          const scrollTarget = targetPosition + window.pageYOffset - headerHeight;
    
          window.scrollTo({
            top: scrollTarget,
            behavior: "smooth"
          });   
        }
      }

      e.preventDefault();
    });
  }
}

customElements.define('scroll-to', ScrollTo);

class CustomerForm {
  constructor() {
    this.init();
  }

  init() {
    const customerForms = document.querySelectorAll('.js-customer-form');
    let target;
    let scrollTo = false;

    customerForms.forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        sessionStorage.setItem('customer_form', '#' + form.id);
        form.submit();
      })
    })

    if (location.search === '?customer_posted=true') {
      if (location.hash) {
        target = location.hash;
      } else {
        target = sessionStorage.getItem('customer_form');
        sessionStorage.removeItem('customer_form');
        scrollTo = true;
      }
  
      if (!target) return;
  
      const form = document.querySelector(target);
  
      if (!form) return;
  
      const message = form.querySelector('.js-form-success-message');
  
      if (!message) return;
  
      message.classList.remove('hidden');
  
      if (scrollTo) {
        form.scrollIntoView({
          behavior: 'instant'
        });
      }
    }
  }
}

new CustomerForm();
